document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.imageListSwiper', {
        loop: false,
        pagination: {
            el: '.swiper-pagination',
        },
    });
    if (window.innerWidth > 768) {
        const commentSwiper = new Swiper('.commentSwiper', {
            loop: false,
            slidesPerView: 3,
            spaceBetween: 12,
            pagination: {
                el: '.swiper-pagination-comment',
            },
        });
    } else {
        const commentSwiper = new Swiper('.commentSwiper', {
            loop: false,
            spaceBetween: 10,
            pagination: {
                el: '.swiper-pagination-comment',
            },
        });
    }

    const closeSvg = document.querySelector('.cust-view-info-modal-close')
    const modal = document.querySelector('.cust-view-info-modal');
    if (closeSvg && modal) {
        closeSvg.addEventListener('click', function () {
            var viewInfoSections = document.querySelectorAll('.cust-view-info-section')
            var body = document.querySelector('.template-page')
            var podiumWebsite = document.querySelector('#podium-website-widget')
            viewInfoSections.forEach(el => el.style.display = 'none');
            if(body){
              body.style.overflow = 'auto'
            }
            modal.style.display = 'none';
            podiumWebsite.style.display = 'block'
        });
    }

    if (window.innerWidth < 768) {
        const shows = document.querySelectorAll('.showSvg');
        const hides = document.querySelectorAll('.hideSvg');
        const open_hours = document.querySelectorAll('.shopinfo_open_hours');
        const open_hours_hides = document.querySelectorAll('.shopinfo_open_hours .hideSvg');
        const open_hours_shows = document.querySelectorAll('.shopinfo_open_hours .showSvg');
        open_hours.forEach(openHour => {
            openHour.classList.add('shopinfo-hide');
        });
        shows.forEach((showSvg, index) => {
            showSvg.style.display = 'block';

            const shopInfo = showSvg.closest('.shopinfo_open_hours') ||
                showSvg.closest('.shopinfo_address');

            const hideSvg = hides[index];

            showSvg.addEventListener('click', () => {
                if (shopInfo) {
                    shopInfo.classList.add('shopinfo-hide');
                }
                showSvg.style.display = 'none';
                hideSvg.style.display = 'block';
            });

            hideSvg.addEventListener('click', () => {
                if (shopInfo) {
                    shopInfo.classList.remove('shopinfo-hide');
                }
                hideSvg.style.display = 'none';
                showSvg.style.display = 'block';
            });
        });
        open_hours_hides.forEach(i => i.style.display = 'block')
        open_hours_shows.forEach(i => i.style.display = 'none')
    }
})